import TimeSinceNow from './TimeSinceNow';

export default TimeSinceNow;
